import axios from 'axios'
import qs from 'qs'
import { 
    productListRequest,
    productListSuccess,
    productListFail,

    productDetailsRequest,
    productDetailsSuccess,
    productDetailsFail,

    productPublishRequest,
    productPublishSuccess,
    productPublishFail,

    brandListRequest,
    brandListSuccess,
    brandListFail,
} from '../reducers/productReducers'

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    return axios.create({
        baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/products`,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        withCredentials: true
    })
}

export const listProducts = ({keyword= undefined, category= undefined, brands= undefined, userID= undefined, status='all', label=undefined, ordering = 'endDate'}) => async (dispatch) => {
    try {
        dispatch(productListRequest());

        let params = {};

        if (keyword) {
            params.search = keyword;
        }
        if (category && category !== 'all') {
            params.category = category;
        }
        if (brands && brands.length > 0) {
            // Ensure brands is properly passed as an array
            params.brand = Array.isArray(brands) ? brands : [brands];
        }
        if (userID) {
            params.user = userID;
        }
        
        // Always send productStatus parameter
        if (status === 'all') {
            params.productStatus = 'all';
        } else if (status) {
            // Convert to a valid numeric value if needed 
            if (status === 'active' || status === 'live') {
                params.productStatus = 1;
            } else if (status === 'completed' || status === 'ended') {
                params.productStatus = 2;
            } else if (status === 'upcoming') {
                params.productStatus = 3;
            } else if (!isNaN(parseInt(status))) {
                // For numeric status, pass the value directly
                params.productStatus = parseInt(status);
            }
        }
        
        if (label && label !== 'all') {
            params.label = label;
        }
        
        // Handle ordering parameter
        if (ordering) {
            // If it includes a colon, we need to parse it
            if (ordering.includes(':')) {
                const [field, direction] = ordering.split(':');
                if (direction === '-1') {
                    // For descending order, prefix the field with a minus sign
                    params.ordering = `-${field}`;
                } else {
                    // For ascending order, use the field as is
                    params.ordering = field;
                }
            } else {
                // If no colon, use the value directly (backward compatibility)
                params.ordering = ordering;
            }
        }
        
        const api = createAPIinstance()
        
        // Use qs.stringify which properly handles arrays
        const { data } = await api.get(`/?${qs.stringify(params, { arrayFormat: 'repeat' })}`);

        dispatch(productListSuccess(data));
    } catch (error) {
        dispatch(productListFail(
            error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        ));
    }
};

export const detailProducts = (id) => async (dispatch) => {
    try{
        dispatch(productDetailsRequest())

        const api = createAPIinstance()
        const { data } = await api.get(`/${id}`)

        dispatch(productDetailsSuccess(data))
    }catch(error){
        dispatch(productDetailsFail(error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        ));
    }
}

export const publishProduct = (product) => async (dispatch) => {
    try{
        dispatch(productPublishRequest())

        const api = createAPIinstance()
        // For multipart/form-data, we need to set the CSRF token specifically
        const csrfToken = getCsrfToken();
        const { data } = await api.post('/', product, {
            headers: {
                "Content-Type": 'multipart/form-data',
                'X-CSRFToken': csrfToken
            }
        })

        dispatch(productPublishSuccess(data))
    }catch(error){
        dispatch(productPublishFail(
            error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        ))
    }
}

export const listBrands = () => async (dispatch) => {
    try {
        dispatch(brandListRequest())

        const api = createAPIinstance()
        const { data } = await api.get('/brands/')

        dispatch(brandListSuccess(data))
    } catch (error) {
        dispatch(brandListFail(
            error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        ))
    }
}
